import React from "react";
import "../../index.css";
import { Link } from "react-router";
import { Tooltip } from "react-tooltip";
import slctemple from '../../Assets/Img/slctemple.png'

const Chap2 = () => {
  return (
    <div className="chapter-container">

      <div className="chapterFooter">
          <Link to="/Chap1">Previous</Link>
          <Link to="/">Home</Link>
          <Link to="/Chap3">Next</Link>
      </div>

      <h1 className="chapterHeading">
        Chapter 2: Daniel’s Stone Cut of the Mountain
      </h1>
    
      <img src={slctemple} className='image' alt='Mormon Salt Lake City temple' />

    <div className="wrapper">

      <div>
        <p className='paragraph'>
          Is the Mormon church a church or a kingdom – the literal Kingdom of God on earth as Joseph Smith claimed?
          Mormon apostle D. Todd Christofferson referred to the church as the Kingdom of God. “The
          fulfillment of those prophecies and promises is now underway with the gathering of the covenant people into the Church, the kingdom of God
          on earth.” 
          <btn id="clickable1" className="footnote">1  </btn>
          <Tooltip anchorSelect="#clickable1" className="footnote-size" clickable>D. Todd Christofferson, Spring 2021 General Conference, “Why the Covenant Path?”</Tooltip> 
          Mormon apostle David Bednar quoted scripture saying Mormons, “should ‘… be instructed more perfectly in theory, in
          principle, in doctrine, in the law of the gospel, in all things that pertain unto the kingdom of God.’”
          <btn id="clickable2" className="footnote">2  </btn>
          <Tooltip anchorSelect="#clickable2" className="footnote-size" clickable>David Bednar, Spring 2021 General Conference, “The Principles of My Gospel.”</Tooltip> 
        </p>
      </div>

      <div className="paragraph">
        <p>
          In the New Testament, Christ mentions establishing the Kingdom of God on earth. John writes, “Except man be born again, he cannot see the
          kingdom of God.” 
          <btn id="clickable3" className="footnote">3  </btn>
          <Tooltip anchorSelect="#clickable3" className="footnote-size" clickable>John 3:3.</Tooltip> 
          
          Luke writes, “But rather seek ye the kingdom of God” and “it is your Father’s good pleasure to give you the kingdom.”
          <btn id="clickable4" className="footnote">4  </btn>
          <Tooltip anchorSelect="#clickable4" className="footnote-size" clickable>Luke 12:30-32.</Tooltip> 
          
          Mark writes, “how hardly shall they that have riches enter into the kingdom of God!”
          <btn id="clickable5" className="footnote">5  </btn>
          <Tooltip anchorSelect="#clickable5" className="footnote-size" clickable>Mark 10:23.</Tooltip>  
          
          And Matthew writes, “And I will give unto thee the keys of the kingdom of heaven.”
          <btn id="clickable6" className="footnote">6  </btn>
          <Tooltip anchorSelect="#clickable6" className="footnote-size" clickable>Matthew 16:19.</Tooltip>  

        </p>
      </div>

      <div className="paragraph">
        <p>
          Christian churches do not claim to be the Kingdom of God. Rather, they
          anticipate Christ’s return to earth and the establishment of a
          Millennial Kingdom. However, Joseph Smith revealed in 1831, “The keys
          of the Kingdom of God are committed unto man on the earth, and from
          thence shall the gospel roll forth unto the ends of the earth, as the
          stone which is cut out of the mountain without hands shall roll forth,
          until it has filled the whole earth.”
          <btn id="clickable7" className="footnote">7  </btn>
          <Tooltip anchorSelect="#clickable7" className="footnote-size" clickable>D&C 65:2.</Tooltip>  
        </p>
      </div>

      <div className="paragraph">
        <p>
          Daniel, in the Old Testament, prophesied that the Kingdom of God would begin small, as a stone cut out of a mountain, and would one day fill 
          the entire world, ushering in the Millennium. 
          <btn id="clickable8" className="footnote">8  </btn>
          <Tooltip anchorSelect="#clickable8" className="footnote-size" clickable>Daniel 2:19.</Tooltip> 
          
          For the early Mormons,
          fulfilling Daniel’s prophecy was front and center of Joseph Smith’s
          Mormonism. Joseph stated, “I calculate to be one of the instruments of
          setting up the kingdom of Daniel by the word of the Lord, and I intend
          to lay a foundation that will revolutionize the whole world.”
          <btn id="clickable9" className="footnote">9  </btn>
          <Tooltip anchorSelect="#clickable9" className="footnote-size" clickable>Statement on 12 May 1844 to the Council of Fifty, as recorded in Underwood, 
            the Millenarian World of Early Mormonism, 109.</Tooltip> 
        </p>
      </div>

      <h2 className="headlinePadding" >The Literal Kingdom of God in the Last Days</h2>
     
      <div className="paragraph">
        <p>
          Joseph and the early Mormons believed that they had established the
          Kingdom of God in their day. Yet today the church teaches that the
          Kingdom of God is a concept that will come to pass in the future. “The
          kingdom of God means the government of God ... But that principle will
          not be fulfilled … until, as we are told in the scriptures, the
          kingdoms of this world are become the kingdoms of our Lord and his
          Christ, and he will rule over them, and when unto him every knee shall
          bow, and every tongue confess that he is Christ ... That time has not
          yet come.”
          <btn id="clickable10" className="footnote">10  </btn>
          <Tooltip anchorSelect="#clickable10" className="footnote-size" clickable>The Gospel Kingdom, sel. G. Homer Durham (1943), 205.</Tooltip>

        </p>
      </div>

      <div className="paragraph">
        <p>
          However, historian Klaus Jansen noted, “If [Joseph] Smith waited until
          1844 before he formally organized the government of the kingdom, the
          logic behind that move goes back to the very beginning of the new
          religion, because he never conceived of Mormonism as merely another
          sect.”
          <btn id="clickable11" className="footnote">11  </btn>
          <Tooltip anchorSelect="#clickable11" className="footnote-size" clickable>Klaus Jansen, Mormonism and the American Experience, 132.</Tooltip>
          
        </p>
      </div>

      <div className="paragraph">
        <p>By the end of his life, Joseph believed that he had established
          the Kingdom of God. He stated, “I have done what king Solomon, King
          Hiram, & Hiram Abiff could not do: I have set up the kingdom no more
          to be thrown down forever nor never to be given to another people.”
          <btn id="clickable12" className="footnote">12  </btn>
          <Tooltip anchorSelect="#clickable12" className="footnote-size" clickable>Dimick B. Huntington, State of Dimick B. Huntington, December 12, 1878, Salt Lake City.</Tooltip>

          Joseph even had himself crowned as king of the Kingdom of God as “King, Priest, and Ruler over Israel on the Earth.” 
          <btn id="clickable13" className="footnote">13  </btn>
          <Tooltip anchorSelect="#clickable13" className="footnote-size" clickable>See Council of Fifty in this essay. The Council of Fifty was established by Joseph Smith in 1844. Its purpose was to organize the political kingdom of God in preparation for the Second Coming of Christ. (See Church History in the Fulness of Times, 270.) Eventually 50 men were admitted to the Council who witnessed Joseph’s ordination as “King, Priest, and Ruler over Israel on the Earth” – and the placing of a crown upon his head. To keep the Council of Fifty secret, Joseph administered a secrecy oath under the penalty of death. (See William Clayton Diary, 1 Mar. 1845, in Smith, An Intimate Chronicle, 158.)</Tooltip>
          
          More on this later.
        </p>
      </div>

      <div className="paragraph">
        <p>
          Mormons today are not taught that Joseph Smith was crowned King of the Kingdom of God as “King, Priest, and Ruler over Israel on the Earth.”
          <btn id="clickable14" className="footnote">14  </btn>
          <Tooltip anchorSelect="#clickable14" className="footnote-size" clickable>See Council of Fifty in this essay. The Council of Fifty was established by Joseph Smith in 1844. Its purpose was to organize the political kingdom of God in preparation for the Second Coming of Christ. (See Church History in the Fulness of Times, 270.) Eventually 50 men were admitted to the Council who witnessed Joseph’s ordination as “King, Priest, and Ruler over Israel on the Earth” – and the placing of a crown upon his head. To keep the Council of Fifty secret, Joseph administered a secrecy oath under the penalty of death. (See William Clayton Diary, 1 Mar. 1845, in Smith, An Intimate Chronicle, 158.)</Tooltip>

          If Joseph was crowned, was Mormon prophet Russell Nelson also crowned
          as the current “King, Priest, and Ruler over Israel on the Earth” when
          he became the Mormon prophet? Joseph Smith’s successors Brigham Young
          and John Taylor were both anointed Kings when they became the prophet
          in secret ceremonies for which we have documentary evidence.
        </p>
      </div>

      <div className="paragraph">
        <p>
          Perhaps the latest group of Mormon prophets forgo being covertly
          crowned in our modern day – a bad look. But do they secretly consider
          themselves as the King of the Kingdom of God as “King, Priest, and
          Ruler over Israel on the Earth” and God’s representative to preside
          over all earthly kingdoms? Russell Nelson is one of the richest men in
          the world, given his position as head of the Mormon church and
          financial structure of the church, 
          <btn id="clickable15" className="footnote">15  </btn>
          <Tooltip anchorSelect="#clickable15" className="footnote-size" clickable>The Mormon Church is a corporation sole owned entirely 
            by the office of the president of the 
            church. That put’s Nelson’s net worth at 265 billion making him at least in the top 3-5 wealthiest people on the planet.</Tooltip>
          
          and as they say, it is good to be the king.
        </p>
      </div>

      <div className="paragraph">
        <p>
          A secretive body known as the Council of Fifty witnessed Joseph
          Smith’s ordination as “King, Priest, and Ruler over Israel on the
          Earth” – and the placing of a crown upon his head. Nauvoo Stake
          President William Marks stated, “I was also witness of the
          introduction (secretly) of a kingly form of government, in which
          Joseph suffered himself to be ordained a king, to reign over the house
          of Israel forever.”
          <btn id="clickable16" className="footnote">16  </btn>
          <Tooltip anchorSelect="#clickable16" className="footnote-size" clickable>William Marks, Zion's Harbinger and Baneemy's Organ, St. Louis, 
            July 1853, p. 53.</Tooltip>
          
          George Miller remarked, “In this council we ordained Joseph Smith as King on earth.” 
          <btn id="clickable17" className="footnote">17  </btn>
          <Tooltip anchorSelect="#clickable17" className="footnote-size" clickable>Klaus Hansen, The Theory and Practice of the Political 
            Kingdom of God in Mormon History, 1829-1890, master's thesis, BYU, 1959, p. 114.</Tooltip>
          
          Council secretary William Clayton recorded, “… Joseph was chosen as our prophet, priest & king by hosanas.” 
          <btn id="clickable18" className="footnote">18  </btn>
          <Tooltip anchorSelect="#clickable18" className="footnote-size" clickable>William Clayton Journal, 11 April 1844, 1 January 1845, 
            quoted in Allen, “One Man’s Nauvoo,” footnotes. 21 and 22.</Tooltip>

          In a revelation given to third Mormon prophet John Taylor, “mention is made of Joseph Smith being crowned a king in Nauvoo.”
          <btn id="clickable19" className="footnote">19  </btn>
          <Tooltip anchorSelect="#clickable19" className="footnote-size" clickable>Diary of George A. Smith, May 9,1844, located in the Library of the 
            Church Historian; Kenneth W. Godfrey, former director of the LDS Institute at Stanford University, 
            BYU Studies, Winter 1968, pp. 212-13, quoted in doctoral dissertation Causes of Mormon Non-Mormon 
            Conflict in Hancock County, Illinois, 1839-1846, Ph.D. dissertation, BYU, 1967, pp. 63-65.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          The second anointing is a secretive temple ordinance never discussed
          publicly by church leaders. Russell Nelson, and all upper echelon
          Mormon leaders, have received this pinnacle ordinance. In the second
          anointing, as Joseph Smith taught, a person is anointed as a “priest
          and king” and conferred godhood.
          <btn id="clickable20" className="footnote">20  </btn>
          <Tooltip anchorSelect="#clickable20" className="footnote-size" clickable>Greg Prince, August 15, 1995, Ordinances: The Second Anointing. Power from on High, p. 189, 191.</Tooltip>
          
          It stands to reason that crowning the
          Mormon prophet as “King, Priest, and Ruler over Israel on the Earth”
          is another secretive ordinance never discussed publicly for obvious
          reasons.
        </p>
      </div>

      <div className="paragraph">
        <p>
          The Mormon church teaches that there is a clear line of succession
          from Joseph Smith to each subsequent Mormon prophet – a continuing
          chain of priesthood authority and keys. Each successor holds the same
          priesthood keys to administer the affairs of the Kingdom of God.
          Joseph taught, “The keys (of the priesthood) have to be brought from
          heaven whenever the Gospel is sent.” 
          <btn id="clickable21" className="footnote">21  </btn>
          <Tooltip anchorSelect="#clickable21" className="footnote-size" clickable>Teachings of Presidents of the Church: Joseph Smith [2007], 104.</Tooltip>
          
          The keys necessary for governing
          the Church in the latter days were restored to Joseph Smith by
          heavenly beings – for instance, John the Baptist, Peter, James, John,
          Moses, Elias, and Elijah.
          <btn id="clickable22" className="footnote">22  </btn>
          <Tooltip anchorSelect="#clickable22" className="footnote-size" clickable>Joseph Smith – History 1:72; D&C 27:12; D&C 110:11–12.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Therefore, if these priesthood keys are possessed by Russell Nelson,
          and God is the same yesterday, today, and forever, have all Mormon
          prophets been crowned as “King, Priest, and Ruler over Israel on the
          Earth” in secretive ceremonies as was Joseph Smith, Brigham Young, and
          John Taylor, for which we have documentary evidence? Were the other
          bestowals of crowns kept secret for all other succeeding Mormon
          prophets? As has been revealed, the Mormon church tends to hide things
          from its members.
        </p>
      </div>

      <div className="paragraph">
        <p>So, let’s look to see whether the Mormon church
          believes that it is a church or God’s literal kingdom on the earth.
        </p>
      </div>

      

      <h2 className="headlinePadding" >The Prophecy that Started it All</h2>
      <div className="paragraph">
        <p>
          In the Old Testament, Daniel, a noble Jewish youth, is taken captive
          into Babylon around 605 BCE. Although faithful to the God of Israel,
          Daniel serves the Babylonian King as a slave in the King’s court.
          Then, one day, through his prophetic gifts, Daniel interpreted the
          meaning of the King’s dream.
          <btn id="clickable23" className="footnote">23  </btn>
          <Tooltip anchorSelect="#clickable23" className="footnote-size" clickable>Daniel 2:19.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          According to Daniel’s interpretation, the dream foretells future world
          history and the eventual establishment of the Kingdom of the God of
          Israel that will rule over all political kingdoms – an interesting
          story coming from a people just brought into bondage by the
          Babylonians. Daniel saw an image of a man with “head of fine gold, and
          breast and arms of silver, and belly and thighs of brass, and legs of
          iron, and feet of iron and clay.” Then, a small stone cut out of a
          mountain without hands begins to roll. Gaining momentum, it strikes
          the image of the man breaking it to pieces. Then the stone becomes a
          great mountain and fills the entire earth.
        </p>
      </div>

      <div className="paragraph">
        <p>
          Daniel’s prophecy about the establishment of Israel’s Kingdom of God
          has figured prominently in Mormon theology. Joseph Smith and other
          leaders have taught that the rise of the Mormon church was the
          fulfillment of Daniel’s prophecy. For nearly 170 years, up until the
          2000s, the Mormon church had set itself up, as an “ensign to all
          nations” of truth restored that will gather in the elect of the earth,
          and usher in the Second Coming and Millennium reign of Christ.
        </p>
      </div>

      <div className="paragraph">
        <p>
          But in the Mormon church, where has the Kingdom of God rhetoric been
          for the last 25 years? 
          <btn id="clickable24" className="footnote">24  </btn>
          <Tooltip anchorSelect="#clickable24" className="footnote-size" clickable>Mormon Apostle Neal Anderson made passing mention to Daniel’s prophecy and how the Mormon church is the literal kingdom of God in the October 2016 general conference. “The God of heaven,” Daniel said, “[shall] set up a kingdom, [a stone cut out without hands, that will become a great mountain and fill the whole earth,] never [to] be destroyed … [but to] stand for ever … From the miraculous intervention of God to Daniel came the prophesied future of the gospel of Jesus Christ being restored to the earth, a kingdom that would fill the whole earth, ‘never [to] be destroyed … [but to] stand for ever.’ The number of members of the Church in the latter days would be relatively few, as Nephi prophesied, but they would be upon all the face of the earth.”</Tooltip>

          Why the radio silence? Perhaps declining church
          membership (less than four million attending Mormons) indicates a
          shrinking kingdom, not one that will fill all the earth and to which
          all nations will bow.
        </p>
      </div>

      <h2 className="headlinePadding" >Beginnings of the Mormon Kingdom</h2>
      <div className="paragraph">
        <p>
          In 1834 Joseph said, “I want to say to you before the Lord, that you
          know no more concerning the destinies of this Church and kingdom than
          a babe upon its mother’s lap. You don’t comprehend it … this Church
          will fill North and South America – it will fill the world.”
          <btn id="clickable25" className="footnote">25  </btn>
          <Tooltip anchorSelect="#clickable25" className="footnote-size" clickable>Wilford Woodruff, Conference Report, Apr. 1898, p. 57.</Tooltip>

        </p>
      </div>

      <div className="paragraph">
        <p>
          Mormon apostle Parley Pratt published in 1838, “His [Joseph] works
          will live to endless ages, and unnumbered millions yet unborn will
          mention his name with honor … during his short and youthful career,
          [he] laid the foundation of that kingdom spoken of by Daniel, the
          prophet, which should break in pieces all other kingdoms and stand
          forever.”
          <btn id="clickable26" className="footnote">26  </btn>
          <Tooltip anchorSelect="#clickable26" className="footnote-size" clickable>Autobiography of Parley Parker Pratt, 6th ed., 1938, p. 46.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Brigham stated in 1852, “The Lord God Almighty has set up a kingdom
          that will sway the scepter of power and authority over all the
          kingdoms of the world, and will never be destroyed, it is the kingdom
          that Daniel saw and wrote of. It may be considered treason to say that
          the kingdom which that Prophet foretold is actually set up; … The
          kingdom will continue to increase, to grow, to spread and prosper more
          and more … and become more wonderful and conspicuous to the nations,
          until it fills the whole earth.” 
          <btn id="clickable27" className="footnote">27  </btn>
          <Tooltip anchorSelect="#clickable27" className="footnote-size" clickable>Brigham Young, Journal of Discourses, April 6, 1852, vol. 1, p. 202-203.</Tooltip>

        </p>
      </div>
          
      <div className="paragraph">
          <p>
          Brigham stated of the church in 1859,
          “… there is no true government on earth but the government of God, or
          the holy Priesthood … In short, it is a perfect system of government –
          a kingdom of Gods and angels and all beings who will submit themselves
          to that government. There is no other true government in heaven or
          upon the earth.” 
          <btn id="clickable28" className="footnote">28  </btn>
          <Tooltip anchorSelect="#clickable28" className="footnote-size" clickable>Brigham Young, Journal of Discourses, May 22, 1859, vol. 7, p. 139-147.</Tooltip>

          Mormon apostle Heber Kimball stated in 1859, “That
          which the world calls ‘Mormonism’ is the kingdom of God – the kingdom
          which Daniel saw; and this kingdom Joseph Smith was sent by the
          Almighty to establish, with its priesthood and authorities; and we
          shall prosper exceedingly, if we cleave to it.”
          <btn id="clickable29" className="footnote">29  </btn>
          <Tooltip anchorSelect="#clickable29" className="footnote-size" clickable>Heber Kimball, Journal of Discourses, October 7, 1859, vol. 7, p. 329.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Third Mormon prophet John Taylor stated in 1858, “God has set his hand
          to work to accomplish his purposes, to gather together his people, to
          establish the principles of righteousness among men, and overthrow the
          kingdom of darkness, and establish his kingdom, and afford protection
          to the honest in heart among all nations, to introduce a reign of
          righteousness that shall ultimately prevail over the world.”
          <btn id="clickable30" className="footnote">30  </btn>
          <Tooltip anchorSelect="#clickable30" className="footnote-size" clickable>John Taylor, Journal of Discourses, January 10, 1858, vol. 7, p. 124.</Tooltip>
        </p>

        <h2 className="headlinePadding" >The Last Mormon Prophetic Statements about Daniel’s Prophecy</h2>

        <div className="paragraph">
          <p>
            In 1976, twelfth Mormon prophet Spencer Kimball spoke of Daniel’s
            prophecy. “Cyrus the great, with his Medes and Persians, would be
            replaced by the Greek or Macedonian kingdom under Philip and
            Alexander; and that world power would be replaced by the Roman
            Empire; and Rome would be replaced by a group of nations of Europe
            represented by the toes of the image.”
            <btn id="clickable31" className="footnote">31  </btn>
            <Tooltip anchorSelect="#clickable31" className="footnote-size" clickable>Spencer Kimball, The Stone Cut without Hands, General Conference, April 1976.</Tooltip>
          </p>
        </div>

        <div className="paragraph">
          <p>
            Spencer Kimball then quotes Daniel, “Then shall the God of heaven set up a
            kingdom, which shall never be destroyed: and the kingdom shall not
            be left to other people, but it shall break in pieces and consume
            all these kingdoms, and it shall stand forever.” 
            <btn id="clickable32" className="footnote">32  </btn>
            <Tooltip anchorSelect="#clickable32" className="footnote-size" clickable>Spencer Kimball, The Stone Cut without Hands, General Conference, April 1976.</Tooltip>
            
            In that talk
            Spencer Kimball quotes a revelation to Joseph Smith, “And even so I have
            sent mine everlasting covenant into the world … to be a standard for
            my people … Wherefore, come ye unto it.” 
            <btn id="clickable33" className="footnote">33  </btn>
            <Tooltip anchorSelect="#clickable33" className="footnote-size" clickable>D&C 45:1-3, 9, 10.</Tooltip>
            
            Then Spencer Kimball goes on to
            refer to this standard. “This is the kingdom of God upon the earth,
            for it is Jesus Christ who organized this kingdom.”
          </p>
        </div>

        <div className="paragraph">
          <p>
            Continuing, Spencer Kimball gave an outline of the restoration of the Mormon
            gospel. He spoke of how after “numerous revelations from the divine
            source” were given in 1830, the kingdom was “set up by the God of
            heaven, that would never be destroyed nor superseded, and the stone
            cut out of the mountain without hands that would become a great
            mountain and would fill the whole earth.”
          </p>
        </div>

        <div className="paragraph">
          <p>
            According to Spencer Kimball, the Mormon church would be the standard to
            which “the honest in heart might be looking forward.” Recalling
            Joseph Smith’s claim as restorer, Spencer Kimball added, “It came about in a
            regular, normal process. An inspired, fourteen-year-old boy … [i]n a
            dense grove of trees sought the Lord and prayed for wisdom.” The
            time had arrived “and though the adversary, Satan, recognizing all
            the powers of eternity which would be revealed with the gospel, did
            everything in his power to destroy the lad and destroy the prospects
            of the Restoration.”
          </p>
        </div>

        <div className="paragraph">
          <p>
            To establish the Mormons’ claims to divine authority to erect and
            then carry forth the “standard” Kimball continued, “In quick
            succession there came other visitors. Peter, James, and John – men
            who last held the keys of the kingdom, the power of the priesthood,
            and the blessings of eternity – appeared … and restored … power and
            authority. John the Baptist … returned to the earth and laid hands
            on the Prophet Joseph to give him the Aaronic Priesthood. The great
            Moses of antiquity returned to the earth … Elijah, the prophet …
            returned to make way and prepare for the great temple work … Moroni
            appeared … and spent long hours explaining the peopling of the
            American continents by the Lehites and also the Book of Mormon … the
            gospel was revealed, line upon line and precept upon precept, and
            truths were restored, and power was given and authority was
            revealed, and gradually enough light and enough people were there
            for the organization of this kingdom of God which Daniel saw two and
            a half millennia ago.” 
            <btn id="clickable34" className="footnote">34  </btn>
            <Tooltip anchorSelect="#clickable34" className="footnote-size" clickable>Spencer Kimball, The Stone Cut without Hands, Genal Conference, April 1976.</Tooltip>
          </p>
        </div>
            
        <div className="paragraph">
          <p>   
            Up until the 2000s, a chorus of Mormon
            leaders claimed the Mormon church was the literal fulfillment of
            Daniel’s prophecy. Apostle Bruce McConkie published in the late
            1980s in his book Mormon Doctrine, “The Church of Jesus Christ of
            Latter-day Saints as it is now constituted is the kingdom of God on
            earth … The kingdom is here, and it is the same kingdom which Daniel
            said would be set up in the last days.” 
            <btn id="clickable35" className="footnote">35  </btn>
            <Tooltip anchorSelect="#clickable35" className="footnote-size" clickable>Bruce McConkie, Mormon Doctrine, 2d edition, p. 415.</Tooltip>

            In 1988, Prophet Ezra Benson
            stated, “I testify that The Church of Jesus Christ of Latter-day
            Saints is the kingdom which Daniel prophesied God would set up in
            the latter days, never to be destroyed, a stone that would
            eventually fill the whole earth and stand forever.”
            <btn id="clickable36" className="footnote">36  </btn>
            <Tooltip anchorSelect="#clickable36" className="footnote-size" clickable>Erza Benson, General Conference, Oct 1988.</Tooltip>
          </p>
        </div>

        <div className="paragraph">
          <p>
            In 1999, Prophet Gordon Hinckley, stated concerning the
            establishment of Mormonism, “After centuries of darkness and pain
            and struggle, the time was ripe for the restoration of the gospel
            ... The Almighty Judge of the nations, the Living God, determined
            that the times of which the prophets had spoken had arrived. Daniel
            had foreseen a stone which was cut out of the mountain without
            hands, and which became a great mountain and filled the whole earth.
            ‘And in the days of these kings shall the God of heaven set up a
            kingdom, which shall never be destroyed: and the kingdom shall not
            be left to other people, but it shall break in pieces and consume
            all these kingdoms, and it shall stand for ever (Dan. 2:44).’”
            <btn id="clickable37" className="footnote">37  </btn>
            <Tooltip anchorSelect="#clickable37" className="footnote-size"  clickable>Gordon Hinckley, At the Summit of the Ages, 1999.</Tooltip>
          </p>
        </div>

        <div className="paragraph">
          <p>
            By 1844, Joseph had instilled in his followers an inspiring vision
            of the Mormon church as the nascent catalyst that would grow in
            power and might in the last days. He had his followers believing
            that they were called and ordained from the foundation of the world
            to play mighty and powerful roles of leadership as members of the
            House of Israel where they would rule over the world as Saviors on
            Mount Zion. This vision extended through the church until the 2000s.
          </p>
        </div>

        <h2 className="headlinePadding" >The Reality of Daniel as an Old Testament Figure</h2>
        <div className="paragraph">
          <p>
            But what if the biblical figure Daniel never existed? This would
            prove that this prophecy is false and a death blow to Mormonism. The
            fact of the matter is that scholars don’t believe Daniel existed.
            There is no extra-biblical evidence to support the view that Daniel
            was a real person. Scholars believe Daniel’s “prophecy” was the work
            of a later scribe from 2nd century BCE under the rule of the Greek
            king Antiochus IV Epiphanes.
          </p>
        </div>

        <div className="paragraph">
          <p>
            If Daniel had been a real person from 6th century BCE, scholars
            question why his account contained so many errors. For example, the
            Book of Daniel gives the wrong date for Daniel’s incarceration in
            Nebuchadnezzar’s court according to historical evidence for the time
            period. He also miscalls Nebuchadnezzar “king” when at that time he
            was a prince.
          </p>
        </div>

        <div className="paragraph">
          <p>
            In chapter 4, Daniel gives an account of Nebuchadnezzar losing his
            mind for a period of time in which he lives, sleeps, and eats in the
            field with the cattle. No such episode is recorded in history. In
            Chapter 5, Daniel refers to Belshazzar as king and as being
            Nebuchadnezzar son, even though it’s known elsewhere that Belshazzar
            was never king and wasn’t related to Nebuchadnezzar. 
          </p>
        </div>

        <div className="paragraph">
          <p>
            In ChapterS
            5, Daniel says that Belshazzar is killed in a violent action when
            Darius the Mede conquers Babylon. But it was Cyrus, a Persian, who
            conquered Babylon, and he did so bloodlessly. There are also no
            historical records of the figure of Darius the Mede. For these and
            other reasons, these errors point to a 2nd century BCE author.
          </p>
        </div>

        <div className="paragraph">
          <p>
            In a time of few written records, it is hard to believe that someone
            who was allegedly an official in the administration of the very
            people he wrote about would do so. All the evidence, for what it’s
            worth, points to Daniel being a fictitious character. Therefore, if
            Daniel was not an historical person, there was no dream from God to
            interpret. There was no stone rolling down the mountain. No Kingdom
            of God for Joseph Smith to restore and build? But let’s move on from
            Daniel’s prophecy to the structure of the Mormon Kingdom in the last
            days.
          </p>
        </div>
        </div>
      </div>

      <div className="chapterFooter">
          <Link to="/Chap1">Previous</Link>
          <Link to="/">Home</Link>
          <Link to="/Chap3">Next</Link>
      </div>
      
    </div>
  );
};

export default Chap2;
